<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                {{ company.id ? $t('company.add.editTitle') : $t('company.add.newTitle') }}
              </div>
            </div>
            <hr style="margin-top: -4px">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label for="Name">
                        <span class="required">*</span> {{ $t('company.add.nameLabel') }}
                      </label>
                      <input
                        id="Name"
                        v-model="company.name"
                        autocomplete="new-password"
                        type="text"
                        class="form-control"
                        placeholder=""
                      >
                    </div>
                    <div class="form-group col-md-3">
                      <label for="Name"> {{ $t('company.add.fantasyNameLabel') }} </label>
                      <input
                        id="Name"
                        v-model="company.fantasy_name"
                        autocomplete="new-password"
                        type="text"
                        class="form-control"
                        placeholder=""
                      >
                    </div>
                    <div class="form-group col-md-3">
                      <label for="Name">
                        <span class="required">*</span> {{ $t('company.add.cnpjLabel') }}
                      </label>
                      <input
                        id="Name"
                        v-model="company.cnpj"
                        v-mask="'99.999.999/9999-99'"
                        autocomplete="new-password"
                        type="text"
                        class="form-control"
                        placeholder=""
                      >
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-2">
                      <label for="Name"> {{ $t('company.add.cepLabel') }} </label>
                      <input
                        id="Name"
                        v-model="company.cep"
                        v-mask="'99999-999'"
                        autocomplete="new-password"
                        type="text"
                        class="form-control"
                        placeholder=""
                        @keyup="buscar"
                      >
                    </div>
                    <div class="form-group col-md-3">
                      <label for="Name"> {{ $t('company.add.addressLabel') }} </label>
                      <input
                        id="Name"
                        v-model="company.address"
                        autocomplete="new-password"
                        type="text"
                        class="form-control"
                        placeholder=""
                      >
                    </div>
                    <div class="form-group col-md-3">
                      <label for="Name"> {{ $t('company.add.neighborhoodLabel') }} </label>
                      <input
                        id="Name"
                        v-model="company.neighborhood"
                        autocomplete="new-password"
                        type="text"
                        class="form-control"
                        placeholder=""
                      >
                    </div>
                    <div class="form-group col-md-1">
                      <label for="Name"> {{ $t('company.add.numberLabel') }} </label>
                      <input
                        id="inputNumero"
                        v-model="company.number"
                        autocomplete="new-password"
                        type="text"
                        class="form-control"
                        placeholder=""
                      >
                    </div>
                    <div class="form-group col-md-3">
                      <label for="Name"> {{ $t('company.add.complementLabel') }} </label>
                      <input
                        id="Name"
                        v-model="company.complement"
                        autocomplete="new-password"
                        type="text"
                        class="form-control"
                        placeholder=""
                      >
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-3">
                      <label for="Name"> {{ $t('company.add.phoneLabel') }} </label>
                      <input
                        id="Name"
                        v-model="company.phone"
                        v-mask="'(99) 99999-9999'"
                        autocomplete="new-password"
                        type="text"
                        class="form-control"
                        placeholder=""
                      >
                    </div>
                    <div class="form-group col-md-3">
                      <label for="EmailDomain">{{ $t('company.add.ufLabel') }}</label>
                      <v-select
                        v-model="company.state_id"
                        :options="ufs"
                        :reduce="(ufs) => ufs.id"
                        :label="'name'"
                        class="vselect"
                        @input="getCities"
                      />
                    </div>
                    <div class="form-group col-md-6">
                      <label for="Name"> {{ $t('company.add.cityLabel') }} </label>
                      <v-select
                        v-model="company.city_id"
                        :options="cities"
                        :reduce="(cities) => cities.id"
                        :label="'name'"
                        class="vselect"
                      />
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label for="Name">
                        <span class="required">*</span> {{ $t('company.add.typeLabel') }}
                      </label>
                      <input
                        id="Name"
                        v-model="company.type"
                        autocomplete="new-password"
                        type="text"
                        class="form-control"
                        placeholder=""
                      >
                    </div>
                    <div class="form-group col-md-3">
                      <label for="Name"> {{ $t('company.add.referenceLabel') }} </label>
                      <input
                        id="Name"
                        v-model="company.reference"
                        autocomplete="new-password"
                        type="text"
                        class="form-control"
                        placeholder=""
                      >
                    </div>
                    <div class="form-group col-md-3">
                      <label for="Name">
                        <span class="required">*</span> {{ $t('company.add.statusLabel') }}
                      </label>
                      <select
                        v-model="company.status"
                        class="form-control"
                      >
                        <option :value="1">
                          {{ $t('common.active') }}
                        </option>
                        <option :value="0">
                          {{ $t('common.inactive') }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <hr>
                  <h5 class="mb-1">
                    {{ $t('company.add.distanceIntegrationTitle') }}
                  </h5>
                  <div class="row">
                    <div class="form-group col-md-3">
                      <label for="distanceEnabled">{{ $t('company.add.integrationEnabledLabel') }}</label>
                      <select
                        id="distanceEnabled"
                        v-model="company.distance_integration_enabled"
                        class="form-control"
                      >
                        <option :value="false">
                          {{ $t('company.add.noOption') }}
                        </option>
                        <option :value="true">
                          {{ $t('company.add.yesOption') }}
                        </option>
                      </select>
                    </div>
                    <div class="form-group col-md-3">
                      <label for="distanceAuto">{{ $t('company.add.refreshLabel') }}</label>
                      <select
                        id="distanceAuto"
                        v-model="company.distance_auto_refresh"
                        :disabled="!company.distance_integration_enabled"
                        class="form-control"
                      >
                        <option :value="false">
                          {{ $t('company.add.manualRefreshOption') }}
                        </option>
                        <option :value="true">
                          {{ $t('company.add.autoRefreshOption') }}
                        </option>
                      </select>
                      <small class="text-muted">
                        {{ distanceRefreshHint }}
                      </small>
                    </div>
                    <div class="form-group col-md-3">
                      <label for="distanceCap">{{ $t('company.add.monthlyCapLabel') }}</label>
                      <input
                        id="distanceCap"
                        v-model.number="company.distance_monthly_element_cap"
                        :disabled="!company.distance_integration_enabled"
                        type="number"
                        min="1"
                        class="form-control"
                        :placeholder="$t('company.add.monthlyCapPlaceholder')"
                      >
                    </div>
                    <div class="form-group col-md-3">
                      <label for="distancePrice">{{ $t('company.add.pricePerElementLabel') }}</label>
                      <input
                        id="distancePrice"
                        v-model.number="company.distance_price_per_element"
                        :disabled="!company.distance_integration_enabled"
                        type="number"
                        min="0"
                        step="0.00001"
                        class="form-control"
                        :placeholder="$t('company.add.pricePlaceholder')"
                      >
                    </div>
                    <div class="form-group col-md-3">
                      <label>{{ $t('company.add.capInReaisLabel') }}</label>
                      <p class="form-control-plaintext mb-0">
                        {{ distanceCapInReais }}
                      </p>
                    </div>
                  </div>

                  <div
                    v-if="usage"
                    class="row"
                  >
                    <div class="col-md-12">
                      <div class="d-flex align-items-center justify-content-between mb-1">
                        <h6 class="mb-0">
                          {{ $t('company.add.usageTitle') }}
                        </h6>
                        <div
                          class="d-flex align-items-center"
                          style="gap: 8px"
                        >
                          <select
                            v-if="anosDisponiveis.length > 1"
                            v-model="anoSelecionado"
                            class="form-control form-control-sm"
                            style="width: auto"
                          >
                            <option
                              v-for="ano in anosDisponiveis"
                              :key="ano"
                              :value="ano"
                            >
                              {{ ano }}
                            </option>
                          </select>
                          <button
                            type="button"
                            class="btn btn-sm btn-outline-primary"
                            :disabled="loadingUsage"
                            @click="loadUsage(company.id)"
                          >
                            <feather-icon
                              icon="RefreshCwIcon"
                              size="13"
                              class="mr-25"
                            />
                            {{ loadingUsage ? $t('company.add.updatingButton') : $t('company.add.updateButton') }}
                          </button>
                        </div>
                      </div>

                      <div class="border rounded p-1 mb-1">
                        <div class="d-flex justify-content-between align-items-end flex-wrap">
                          <div>
                            <div
                              class="text-muted text-uppercase"
                              style="font-size: 11px; letter-spacing: 0.06em"
                            >
                              {{ $t('company.add.usageInMonth', { month: mesLabel(usage.current.period) }) }}
                            </div>
                            <div style="font-size: 22px; font-weight: 600; line-height: 1.2">
                              {{ milhar(usage.current.elements) }}
                              <span
                                class="text-muted"
                                style="font-size: 13px; font-weight: 400"
                              >
                                {{ $t('company.add.usedOfLabel') }}
                                {{ usage.cap === null ? $t('company.add.unlimitedLabel') : milhar(usage.cap) }} {{ $t('company.add.elementsLabel') }}
                              </span>
                            </div>
                          </div>
                          <div class="text-right">
                            <div
                              class="text-muted text-uppercase"
                              style="font-size: 11px; letter-spacing: 0.06em"
                            >
                              {{ $t('company.add.amountThisMonthLabel') }}
                            </div>
                            <div style="font-size: 22px; font-weight: 600; line-height: 1.2">
                              {{ reais(usage.current.amount) }}
                            </div>
                          </div>
                        </div>

                        <div
                          v-if="usage.cap !== null"
                          class="progress mt-1"
                          style="height: 6px"
                        >
                          <div
                            class="progress-bar"
                            :class="usageBarClass"
                            :style="{ width: usagePercent + '%' }"
                          />
                        </div>

                        <small
                          v-if="usage.cap !== null"
                          class="d-block mt-50"
                          :class="usage.current.warning ? 'text-warning' : 'text-muted'"
                        >
                          {{ $t('company.add.remainingElements', { count: milhar(usage.current.remaining) }) }}
                          · {{ $t('company.add.percentOfCapUsed', { percent: usagePercent }) }}
                        </small>
                        <small
                          v-else
                          class="d-block text-muted mt-50"
                        >
                          {{ $t('company.add.noCapConfigured') }}
                        </small>
                      </div>

                      <table
                        v-if="mesesDoAno.length"
                        class="table table-sm mb-1"
                      >
                        <thead>
                          <tr>
                            <th>{{ $t('company.add.monthOfYear', { year: anoSelecionado }) }}</th>
                            <th class="text-right">
                              {{ $t('company.add.elementsUsedColumn') }}
                            </th>
                            <th class="text-right">
                              {{ $t('company.add.amountChargedColumn') }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="m in mesesDoAno"
                            :key="m.period"
                            :class="{ 'font-weight-bold': m.period === usage.current.period }"
                          >
                            <td>
                              {{ mesLabel(m.period) }}
                              <span
                                v-if="m.period === usage.current.period"
                                class="text-muted font-weight-normal"
                                style="font-size: 11px"
                              >· {{ $t('company.add.inProgressSuffix') }}</span>
                            </td>
                            <td
                              class="text-right"
                              style="font-variant-numeric: tabular-nums"
                            >
                              {{ milhar(m.elements) }}
                            </td>
                            <td
                              class="text-right"
                              style="font-variant-numeric: tabular-nums"
                            >
                              {{ reais(m.amount) }}
                            </td>
                          </tr>
                        </tbody>
                        <tfoot>
                          <tr>
                            <th>{{ $t('company.add.totalOfYear', { year: anoSelecionado }) }}</th>
                            <th
                              class="text-right"
                              style="font-variant-numeric: tabular-nums"
                            >
                              {{ milhar(totalDoAno.elements) }}
                            </th>
                            <th
                              class="text-right"
                              style="font-variant-numeric: tabular-nums"
                            >
                              {{ reais(totalDoAno.amount) }}
                            </th>
                          </tr>
                        </tfoot>
                      </table>
                      <p
                        v-else
                        class="text-muted mb-1"
                        style="font-size: 12px"
                      >
                        {{ $t('company.add.noUsageRegistered', { year: anoSelecionado }) }}
                      </p>

                      <small class="text-muted d-block">
                        {{ $t('company.add.elementExplanation') }}
                      </small>
                    </div>
                  </div>

                  <span class="required_fields">
                    <span class="required">*</span>
                    <strong>{{ $t('company.add.requiredFieldsNote') }}</strong>
                  </span>
                  <div class="block text-right">
                    <router-link
                      to="/companies"
                      class="btn btn-back mr-1"
                    >
                      <i class="fa fa-arrow-left" /> {{ $t('common.back') }}
                    </router-link>
                    <a
                      v-if="$hasAbility('cadastro.gerenciar')"
                      class="btn btn-add"
                      @click="save"
                    >
                      {{ $t('common.save') }}
                      <i class="fa fa-save" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vSelect from 'vue-select'
import Loading from 'vue-loading-overlay'
import BaseCrud from '../../layouts/Base/BaseCrud'

export default {
  components: {
    BaseCrud,
    vSelect,
    Loading,
  },
  data() {
    return {
      company: {
        name: '',
        state_id: '',
        city_id: '',
        cep: '',
        address: '',
        neighborhood: '',
        number: '',
        complement: '',
        type: '',
        reference: '',
        phone: '',
        cnpj: '',
        status: '1',
        fantasy_name: '',
        distance_integration_enabled: false,
        distance_auto_refresh: false,
        distance_monthly_element_cap: null,
        distance_price_per_element: null,
      },
      usage: null,
      loadingUsage: false,
      anoSelecionado: String(new Date().getFullYear()),
      ufs: [],
      cities: [],
    }
  },
  computed: {
    usagePercent() {
      if (!this.usage || this.usage.cap === null || !this.usage.cap) return 0
      return Math.min(100, Math.round((this.usage.current.elements / this.usage.cap) * 100))
    },

    usageBarClass() {
      if (!this.usage) return 'bg-success'
      if (this.usage.current.remaining === 0) return 'bg-danger'
      return this.usage.current.warning ? 'bg-warning' : 'bg-success'
    },

    anosDisponiveis() {
      if (!this.usage) return []

      const anos = this.usage.history.map(m => m.period.slice(0, 4))
      if (!anos.includes(this.anoSelecionado)) anos.push(this.anoSelecionado)

      return [...new Set(anos)].sort().reverse()
    },

    mesesDoAno() {
      if (!this.usage) return []
      return this.usage.history.filter(m => m.period.startsWith(`${this.anoSelecionado}-`))
    },

    totalDoAno() {
      return this.mesesDoAno.reduce(
        (soma, m) => ({
          elements: soma.elements + m.elements,
          amount: soma.amount + (m.amount || 0),
        }),
        { elements: 0, amount: 0 },
      )
    },

    distanceRefreshHint() {
      if (!this.company.distance_integration_enabled) return ''
      return this.company.distance_auto_refresh
        ? this.$t('company.add.autoRefreshHint')
        : this.$t('company.add.manualRefreshHint')
    },

    distanceCapInReais() {
      const teto = this.company.distance_monthly_element_cap
      const preco = this.company.distance_price_per_element

      if (!this.company.distance_integration_enabled) return '—'
      if (!teto) return this.$t('company.add.noCapText')
      if (!preco) return this.$t('company.add.enterPriceText')

      return (teto * preco).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      })
    },
  },
  mounted() {
    const self = this

    self.getUfs()

    const { id } = self.$route.params
    if (id) {
      self.getCompany(id)
    }
  },
  methods: {
    buscar() {
      const self = this

      self.naoLocalizado = false

      if (/^[0-9]{5}-[0-9]{3}$/.test(this.company.cep)) {
        $.getJSON(
          `https://viacep.com.br/ws/${this.company.cep}/json/`,
          endereco => {
            if (endereco.erro) {
              self.endereco = {}
              $('#inputNumero').focus()
              self.naoLocalizado = true
              return
            }
            self.endereco = endereco
            self.company.address = self.endereco.logradouro
            self.company.neighborhood = self.endereco.bairro

            const api = `${self.$store.state.api
            }cities?code=${
              endereco.ibge.substring(0, endereco.ibge.length - 1)}`

            axios
              .get(api)
              .then(response => {
                self.company.state_id = response.data.data[0].uf_id
                self.getCities()
                self.company.city_id = response.data.data[0].id
              })
              .catch(error => {
                self.$message(null, error.response.data, 'error')
              })
            $('#inputNumero').focus()
          },
        )
      }
    },
    loadUsage(id) {
      const self = this
      if (!id) return

      self.loadingUsage = true

      axios
        .get(`${self.$store.state.api}companies/${id}/distance-usage`)
        .then(response => {
          self.usage = response.data.data
        })
        .catch(() => {
          self.usage = null
        })
        .finally(() => {
          self.loadingUsage = false
        })
    },

    mesLabel(period) {
      if (!period) return '—'

      const [ano, mes] = period.split('-')
      const nomes = [
        this.$t('company.add.months.january'), this.$t('company.add.months.february'), this.$t('company.add.months.march'),
        this.$t('company.add.months.april'), this.$t('company.add.months.may'), this.$t('company.add.months.june'),
        this.$t('company.add.months.july'), this.$t('company.add.months.august'), this.$t('company.add.months.september'),
        this.$t('company.add.months.october'), this.$t('company.add.months.november'), this.$t('company.add.months.december'),
      ]

      return `${nomes[Number(mes) - 1] || mes}/${ano}`
    },

    milhar(n) {
      if (n === null || n === undefined) return '—'
      return Number(n).toLocaleString('pt-BR')
    },

    reais(v) {
      if (v === null || v === undefined) return '—'
      return Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    },

    save() {
      const self = this
      let api = `${self.$store.state.api}companies`

      if (self.company.id) {
        self.company._method = 'PUT'
        api += `/${self.company.id}`
      }

      self.$loading(true)

      axios
        .post(api, self.company)
        .then(response => {
          self.$message(
            self.$t('company.common.successTitle'),
            self.$t('company.add.savedMessage'),
            'success',
          )
          self.$loading(false)
          this.$router.push('/companies')
        })

        .catch(error => {
          self.$loading(false)
          self.$message(null, error.response.data, 'error')
        })
    },
    getUfs() {
      const self = this
      const api = `${self.$store.state.api}ufs?paginated=false&status=1`

      axios
        .get(api)
        .then(response => {
          self.ufs = response.data.data
        })
        .catch(error => {
          self.$message(null, error.response.data, 'error')
        })
    },
    getCities() {
      const self = this
      const api = `${self.$store.state.api
      }cities?orderByAsc=name&paginated=false&status=1&uf_id=${
        self.company.state_id}`

      axios
        .get(api)
        .then(response => {
          self.cities = response.data.data
        })
        .catch(error => {
          self.$message(null, error.response.data, 'error')
        })
    },
    getCompany(id) {
      const self = this
      const api = `${self.$store.state.api}companies/${id}?with[]=state&with[]=city`
      self.$loading(true)

      axios
        .get(api)
        .then(response => {
          self.company = response.data.data[0]
          self.loadUsage(id)
          self.$loading(false)
        })
        .catch(error => {
          self.$message(null, error.response.data, 'error')
        })
    },
  },
}
</script>
<style scoped>
.profile_user {
  text-align: center;
}
.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}
.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important ;
}
.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>
